import type { GetFlatRatesResponse } from '@fourthwall/services/dist/ShippingApiClient'
import type { ShopResponse } from '@fourthwall/services/dist/ShopsApiClient'

import type { FormValues, ShippingProfilesResponse } from '../Shipping.types'

export const getInitialValues = (
  flatRates?: GetFlatRatesResponse,
  currentShop?: ShopResponse,
  shippingProfiles?: ShippingProfilesResponse,
): FormValues => {
  const shippingLocation = currentShop?.originAddress

  const baseValues = {
    pricingMethod: 'Weighted' as const,
    domesticFirst: '',
    domesticAdditional: '',
    internationalFirst: '',
    internationalAdditional: '',
    useAdditionalShippingFee: false,
    additionalShippingFee: '',
    shippingLocation,
    withShippingGroupsYouShip: shippingProfiles?.configState === 'ENABLED' || false,
  }

  if (!flatRates) {
    return baseValues
  }

  if (flatRates.enabled) {
    return {
      ...baseValues,
      pricingMethod: 'Fixed' as const,
      domesticFirst: flatRates.domesticShippingBasePrice.value.toString() || '',
      domesticAdditional: flatRates.domesticShippingEachAdditionalItemFee.value.toString() || '',
      internationalFirst: flatRates.internationalShippingBasePrice.value.toString() || '',
      internationalAdditional:
        flatRates.internationalShippingEachAdditionalItemFee.value.toString() || '',
    }
  }

  return baseValues
}
